module.exports = __webpack_public_path__ + "static/media/77bc44fc-2832-4e2b-bfb7-506dade78ef4_1.292c0291b2022e8a3517567027474466.0e4186ec.jpeg";